
import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { DATA } from '@/config/data';
import Paging from '@/shared/components/Paging.vue';

import { CumulationHistoryModel } from '@/models/cumulation-history';

import creditServices from '@/services/credit-services';

@Component({
    components: {
        Paging,
        Loading
    }
})
export default class TradeHistories extends Vue {
    private eventEmit = {
        eventCloseTradeHistories: 'eventCloseTradeHistories'
    };

    private pageSettings = {
      rowPerPage: 10,
      pageSize: 3,
      pageIndex: 1,
      total: 0,
    };

    private listCumulationHistories: CumulationHistoryModel[] = [];
    private isLoading = false;

    private async created() {
        this.loadHistories();
        document.documentElement.style.overflow = 'hidden';
    }

    private async destroyed() {
        document.documentElement.style.overflow = 'auto';
    }

    private async loadHistories() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        this.listCumulationHistories = [];
        const result = await creditServices.cumulationHistories(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, '');

        if (result && result.status === 200 && result.data.status === 200) {
            this.pageSettings.total = result.data.total;
            for (const item of result.data.data) {
                const history = new CumulationHistoryModel();
                history.amount = item.Amount;
                history.createDate = item.CreatedDate;
                history.id = item.ID;
                history.orderId = item.OrderId;
                this.listCumulationHistories.push(history);
            }
        }
        this.isLoading = false;
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadHistories();
    }

    onClose() {
        this.$emit(this.eventEmit.eventCloseTradeHistories, true);
    }
}
